import React, { useEffect } from 'react'
import Layout from './layout'
import './App.css'
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom'
import About from './pages/About'
import Home from './pages/Home'
import Contact from './pages/Contact'
import Shop from './pages/Shop'
import Gallery from './pages/Gallery'
import Loader from './layout/Loader'
import CartProduct from './pages/Cart'
import CartPage from './pages/CartPage'
import CheckOut from './pages/CheckOut'
import { WhatsAppFloatingButton } from './layout/Common'
import { Box } from '@mui/material'
import Reviews from './pages/Reviews'


const App = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [pathname]);
  return (
    <>
      <Layout>
        <Box
          sx={{
            alignItems: 'center',
            borderRadius: '8px 8px 0 0',
            cursor: 'pointer',
            display: 'flex',
            fontSize: '18px',
            height: '34px',
            justifyContent: 'center',
            padding: '0 15px',
            position: 'fixed',
            right: 10,
            top: '50%',
            transform: 'rotate(90deg) translate(50%, -50%)',
            transformOrigin: 'top right',
            backgroundColor: '#333',
            color: '#fff',
            zIndex: 11000,
            boxShadow: '0px 0px 8px rgba(0,0,0,0.2)',
            fontWeight: '500',
            fontFamily: '"Jost", sans-serif'
          }}
          onClick={() => navigate('/reviews')}
        >
          ★ Reviews
        </Box>

        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/about' element={<About />} />
          <Route path='/gallery' element={<Gallery />} />
          <Route path='/contact' element={<Contact />} />
          <Route path='/shop' element={<Shop />} />
          <Route path='/cart/:slug' element={<CartProduct />} />
          <Route path='/cartpage' element={<CartPage />} />
          <Route path='/checkout' element={<CheckOut />} />
          <Route path='/reviews' element={<Reviews />} />
        </Routes>
        <WhatsAppFloatingButton />

      </Layout>
    </>
  )
}

export default App
